import {
    useEffect,
    memo
} from 'react'
import { useDashboard } from '@app/layouts/dashboard/Provider'

export default memo(function Account() {
    const { setTitle } = useDashboard()

    useEffect(() => {
        setTitle('الحساب')
    }, [])

    return (
        <></>
    )
})